import type { UseResourceCustomContext } from '@jira/platform__routing-router-resource-with-custom-router-context/src/controllers/types.tsx';
import { useResourceWithCustomRouterContext } from '@jira/platform__routing-router-resource-with-custom-router-context/src/controllers/use-resource-with-custom-router-context/index.tsx';
import { requiredFrontendProperties } from '@jira/router-resources__service-desk-project-getting-started/src/firstProjectResource.tsx';
import {
	INITIAL_PROJECT_TEMPLATE_PROJECT_PROPERTY_KEY,
	SOLUTION_COMPOSER_BLANK_SERVICE_PROJECT_COMPANY_MANAGED_KEY,
} from '@jira/platform__common-constants/src/project-template-type-keys.tsx';
import { GETTING_STARTED_PAGE_EXCLUDED_PROJECT_TEMPLATES } from './manageQueuesArticleId.constants.tsx';

const useInitialProjectTemplateProjectPropertyKeyWithContext = (
	customContext?: UseResourceCustomContext,
): [string | null, boolean] => {
	const { data, loading } = useResourceWithCustomRouterContext(
		requiredFrontendProperties,
		customContext,
	);
	if (!data) {
		return [null, loading];
	}
	return [data[INITIAL_PROJECT_TEMPLATE_PROJECT_PROPERTY_KEY], loading];
};

export const useGettingStartedPageTemplateState = (
	customContext?: UseResourceCustomContext,
): {
	initialProjectTemplate: string | null;
	isInitialProjectTemplateLoading: boolean;
	isExcludedProject: boolean;
	isSolutionComposerTemplate: boolean;
} => {
	const [initialProjectTemplate, isInitialProjectTemplateLoading] =
		useInitialProjectTemplateProjectPropertyKeyWithContext(customContext);

	return {
		initialProjectTemplate,
		isInitialProjectTemplateLoading,
		isExcludedProject: GETTING_STARTED_PAGE_EXCLUDED_PROJECT_TEMPLATES.includes(
			// oxlint-disable-next-line typescript/consistent-type-assertions
			initialProjectTemplate as string,
		),
		isSolutionComposerTemplate:
			initialProjectTemplate === SOLUTION_COMPOSER_BLANK_SERVICE_PROJECT_COMPANY_MANAGED_KEY,
	};
};

export const useIsGettingStartedPageExcludedProject = (
	customContext?: UseResourceCustomContext,
): [boolean, boolean, string | null] => {
	const { initialProjectTemplate, isInitialProjectTemplateLoading, isExcludedProject } =
		useGettingStartedPageTemplateState(customContext);

	return [isInitialProjectTemplateLoading, isExcludedProject, initialProjectTemplate];
};
